import { amdDefine, AppContext } from 'plugin/liferay-widgets-react-web';

import 'external/css!map-css';
// WebApi
import { default as MapConfigWebApi } from './webapi/MapConfigWebApi';
import { default as LogicalLayerWebApi } from './webapi/LogicalLayerWebApi';
import { default as LayerDataSourceWebApi } from './webapi/LayerDataSourceWebApi';
import { default as LayerWebApi } from './webapi/LayerWebApi';
import { default as GeoJsonWebApi } from './webapi/GeoJsonWebApi';
import MapConfigActions from './actions/MapConfigActions';
import DefaultPosition from './plugins/DefaultPosition';
import MapConfigPlugin from './plugins/MapConfigPlugin';
import LeafletLayerManagerPlugin from './plugins/LeafletLayerManagerPlugin';
import FullscreenPlugin from './plugins/FullscreenPlugin';
import MapScalePlugin from './plugins/MapScalePlugin';
import FeatureDisplayPlugin from './plugins/FeatureDisplayPlugin';
import GeometryInputPlugin from './plugins/GeometryInputPlugin';
import RememberMapStatePlugin from './plugins/RememberMapStatePlugin';
import LayerChooserPlugin from './plugins/LayerChooserPlugin';
import BoundingboxInputPlugin from './plugins/BoundingboxInputPlugin';
import ExportToImagePlugin from './plugins/ExportToImagePlugin';
import HWRMPlugin from './plugins/HWRMPlugin';
import GeoJsonPlugin from './plugins/GeoJsonPlugin';
import SelectionDisplayPlugin from './plugins/SelectionDisplayPlugin';
import PrintPlugin from './plugins/PrintPlugin';
import SituationMapPrintPlugin from './plugins/SituationMapPrintPlugin';
import DisplayCoordinatesPlugin from './plugins/DisplayCoordinatesPlugin';
import LayerInfoPlugin from './plugins/LayerInfoPlugin';
import SearchPlugin from './plugins/SearchPlugin';
import OrthoPhotoPlugin from './plugins/OrthoPhotoPlugin';
import './css/icons.scss';
import CoordinatesSearchPlugin from './plugins/CoordinatesSearchPlugin';

export * from './utils/icons';
export * from './utils/map-config-util';
export { default as ClassNames } from './constants/ClassNames';
export { default as FeatureManager } from './utils/FeatureManager';
export { default as featureUtils } from './utils/feature-util';
export { default as DefaultFeatureRenderer } from './FeatureRenderer/DefaultFeatureRenderer';
export { getBoundsFromGeometry, getFeatureId, transformGeometryToFeatures } from './utils/geo-utils';
export { DefaultFeatureRenderer as DefaultFeatureRendererClass } from './FeatureRenderer/DefaultFeatureRenderer';
export { FliwasCanvasRenderer } from './FeatureRenderer/FliwasCanvasRenderer';

export { MapConfigWebApi };

export { LogicalLayerWebApi };

export { LayerDataSourceWebApi };

export { LayerWebApi };

export { GeoJsonWebApi };

AppContext.registerBundle({
    webApis: {
        MapConfigWebApi,
        LogicalLayerWebApi,
        LayerDataSourceWebApi,
        GeoJsonWebApi: GeoJsonWebApi
        //LayerWebApi
    }
});

export { default as GeometryEditControl } from './components/GeometryEditControl';
export { default as GeometryInput } from './components/GeometryInput';
export { default as LocationInput } from './components/LocationInput';
export { default as MapLinkListItem } from './components/MapLinkListItem';
export { default as LayerChooserSidebar } from './components/LayerChooserSidebar';

export { default as RemoteDataGeoJsonLayer } from './layer/RemoteDataGeoJsonLayer';
export { default as RemoteDataStoreGeoJsonLayer } from './layer/RemoteDataStoreGeoJsonLayer';
export { default as DrawerGeoJsonLayer } from './layer/DrawerGeoJsonLayer';

export { default as Map } from './components/Map';

export { default as MapActions } from './actions/MapActions';
export { default as GeoJsonActions } from './actions/GeoJsonActions';

export { default as LeafletSidebar } from './plugins/L.Control.Sidebar';
export { default as ResizableControl } from './plugins/ResizableControl/ResizableControl';
export { default as LeafletSidebarScss } from './css/leaflet-sidebar.scss';
export { default as DrawerPlugin } from './plugins/DrawerPlugin/DrawerPlugin';

export { DefaultPosition };
export { MapConfigPlugin };
export { LeafletLayerManagerPlugin };
export { FullscreenPlugin };
export { MapScalePlugin };
export { FeatureDisplayPlugin };
export { GeometryInputPlugin };
export { RememberMapStatePlugin };
export { LayerChooserPlugin };
export { BoundingboxInputPlugin };
export { ExportToImagePlugin };
export { HWRMPlugin };
export { GeoJsonPlugin };
export { PrintPlugin };
export { SituationMapPrintPlugin };
export { DisplayCoordinatesPlugin };
export { SearchPlugin };
export { LayerInfoPlugin };
export { CoordinatesSearchPlugin };
export { OrthoPhotoPlugin };

const MapPlugins = {
    DefaultPosition,
    MapConfigPlugin,
    LeafletLayerManagerPlugin,
    FullscreenPlugin,
    FeatureDisplayPlugin,
    LayerChooserPlugin,
    GeometryInputPlugin,
    RememberMapStatePlugin,
    ExportToImagePlugin,
    BoundingboxInputPlugin,
    HWRMPlugin,
    SelectionDisplayPlugin,
    GeoJsonPlugin,
    PrintPlugin,
    SituationMapPrintPlugin,
    DisplayCoordinatesPlugin,
    SearchPlugin,
    LayerInfoPlugin,
    CoordinatesSearchPlugin,
    OrthoPhotoPlugin
};

export const MapConfig = undefined;
export const LogicalLayer = undefined;
export const LayerDataSource = undefined;
export const map_plugins_DefaultPosition = DefaultPosition;
export const map_plugins_MapConfigPlugin = MapConfigPlugin;
export const map_plugins_LeafletLayerManagerPlugin = LeafletLayerManagerPlugin;
export const map_plugins_FullscreenPlugin = FullscreenPlugin;
export const map_plugins_FeatureDisplayPlugin = FeatureDisplayPlugin;
export const map_plugins_LayerChooserPlugin = LayerChooserPlugin;
export const map_plugins_GeometryInputPlugin = GeometryInputPlugin;
export const map_plugins_RememberMapStatePlugin = RememberMapStatePlugin;
export const map_plugins_ExportToImagePlugin = ExportToImagePlugin;
export const map_plugins_BoundingboxInputPlugin = BoundingboxInputPlugin;
export const map_plugins_HWRMPlugin = HWRMPlugin;
export const map_plugins_GeoJsonPlugin = GeoJsonPlugin;
export const map_plugins_SelectionDisplayPlugin = SelectionDisplayPlugin;
export const map_plugins_PrintPlugin = PrintPlugin;
export const map_plugins_SituationMapPrintPlugin = SituationMapPrintPlugin;
export const map_plugins_DisplayCoordinatesPlugin = DisplayCoordinatesPlugin;
export const map_plugins_SearchPlugin = SearchPlugin;
export const map_plugins_LayerInfoPlugin = LayerInfoPlugin;
export const map_plugins_CoordinatesSearchPlugin = CoordinatesSearchPlugin;
export const map_plugins_OrthoPhotoPlugin = OrthoPhotoPlugin;

Object.keys(MapPlugins).filter(k => !k.staticPlugin).map(k => {
    const name = 'map_plugins_' + k;
    amdDefine(name, [], () => {
        console.log('Defined Map Plugin from Module Map ' + name);
    });
});

export * from './stores/StoreFactory';

export { default as MapWidget } from './widgets/MapWidget';
export { default as LayerConfigWidget } from './widgets/LayerConfigWidget';
export { default as MapConfigWidget } from './widgets/MapConfigWidget';

MapConfigActions.itemDefaultGrouped('GroupDefaultMapConfig', { groupId: AppContext.getScopeGroupId() }); //early load Default Group MapConfig*/

L.Icon.Default.imagePath = '/o/de.xdot.liferay.map.web/js/lib/leaflet/dist/css/images/';



// WEBPACK FOOTER //
// ./js/map-portlet.js